/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../config/axios";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { URL_API } from "../../config/default";

const Cobros = () => {
  const { isPending, error, data } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/auth/me`, {
        method: "GET", // O 'POST', 'PUT', 'DELETE', etc. dependiendo de tu solicitud
        headers: {
          Authorization: myHeaders, // Un ejemplo de header de autenticación
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "Loading...";

  if (error) return "Error...";

  const submit = async (formdata: any) => {
    const requestOptions = {
      method: "PUT",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/me`, requestOptions)
      .then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);

        return Toast.fire({
          icon: "success",
          title: "Updated in successfully",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const user = data.data;
  console.log(user);

  return (
    <div className="m-auto md:w-[80%]">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">
            Configurá los cobros
          </span>
          <div className="mb-4 border-t-0 border-e-0 border-s-0 border-b">
            <div>
              <span className="block font-bold">Agregá un método de cobro</span>
              <span>
                Para empezar, decirnos cómo podemos enviarte tu dinero.
              </span>
            </div>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                País/Región
              </div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 10px 10px" }}
              >
                <option selected>Argentina (+54)</option>
              </select>
            </div>

            <span>Acá es donde abriste tu cuenta bancaria.</span>
          </div>

          <div className="">
            <span className="block font-bold text-xl">
              ¿Cómo querés recibir los pagos?
            </span>

            <label className="cursor-pointer border flex justify-between shadow-md py-3 px-3 rounded-xl">
              <div>
                <span className="block">Paypal en USD</span>
                <span className="block">1 Día hábil</span>
                <span className="block">
                  Podrian aplicarse tarifas de PayPal
                </span>
              </div>

              <input
                id="default-checkbox"
                type="radio"
                value=""
                name="cobro"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 rounded-2xl"
                defaultChecked={
                  user.receipts.filter(
                    (receipt: { method_receipt_id: number; }) => receipt.method_receipt_id == 1
                  ).length == 0
                    ? false
                    : true
                }
                onChange={() => {
                  const receipt = {
                    //country: "Argentina",
                    method_receipt_id: "1",
                  };
                  const formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("firstname", user.firstname);
                  formData.append("RECEIPTs", JSON.stringify(receipt));
                  submit(formData);
                }}
              />
            </label>

            <label className="cursor-pointer border flex justify-between shadow-md py-3 px-3 rounded-xl">
              <div>
                <span className="block">Cuenta bancaria en ARS</span>
                <span className="block">De 3 a 5 días hábiles</span>
                <span className="block">Sin cargos adicionales</span>
              </div>

              <input
                id="default-checkbox"
                type="radio"
                value=""
                name="cobro"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 rounded-2xl"
                defaultChecked={
                  user.receipts.filter(
                    (receipt: { method_receipt_id: number; }) => receipt.method_receipt_id == 2
                  ).length == 0
                    ? false
                    : true
                }
                onChange={() => {
                  const receipt = {
                    //country: "Argentina",
                    method_receipt_id: "2",
                  };
                  const formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("firstname", user.firstname);
                  formData.append("RECEIPTs", JSON.stringify(receipt));
                  submit(formData);
                }}
              />
            </label>

            <label className="cursor-pointer flex justify-between border shadow-md py-3 px-3 rounded-xl">
              <div>
                <span className="block">Peyoneer en USD</span>
                <span className="block">
                  Tarjeta de debito MasterCard prepaga
                </span>
                <span className="block">24hs o menos</span>
                <span className="block">
                  Podrían aplicarse tarigas de Peyoneer
                </span>
              </div>

              <input
                id="default-checkbox"
                type="radio"
                value=""
                name="cobro"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 rounded-2xl"
                defaultChecked={
                  user.receipts.filter(
                    (receipt: { method_receipt_id: number; }) => receipt.method_receipt_id == 3
                  ).length == 0
                    ? false
                    : true
                }
                onChange={() => {
                  const receipt = {
                    //country: "Argentina",
                    method_receipt_id: "3",
                  };
                  const formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("firstname", user.firstname);
                  formData.append("RECEIPTs", JSON.stringify(receipt));
                  submit(formData);
                }}
              />
            </label>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Cobros;
